<template>
  <div class="contain">
    <Head></Head>
    <div style="height: 70px;"></div>
    <div class="banner" :style="{'background': 'url(' + baseURL + mk1.fileUrl + ')','background-repeat':'no-repeat','background-size':'cover'}">
    <!-- <div class="banner"> -->
      <div class="banner1" style="margin: 0 auto;padding: 170px 120px 0;box-sizing: border-box;">
        <div>
          <div>
            <div style="color: #fff;font-size: 42px;">{{mk1.title}}<br />{{mk1.subtitle}}</div>
            <div style="color: #fff;font-size: 18px;line-height: 96px;">{{mk1.content}}</div>
            <div
              style="width: 150px;height: 50px;border-radius: 40px;background: #fff;text-align: center;line-height: 50px;margin-top: 40px;background: linear-gradient(to bottom right, #02B4E0 40%, #14E1A0 99%);color: #fff;letter-spacing: 2px;cursor: pointer;"
              @click="outerVisible = true">
              立即咨询</div>
          </div>
        </div>
      </div>
      <div class="bj1">
        <div v-for="(item, index) in hotArticlesList" :key="index" style="cursor: pointer;" @click="toDetails(item.id)">
          <div class="hotArticlesTitle"
            style="font-size: 18px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #1F2329;line-height: 25px;color: #1F2329;margin-bottom: 15px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">
            {{item.title}}
          </div>
          <div class="hotArticlesContent"
            style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;line-height: 24px;color: #A1ABBA;word-break: break-all;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;">
            {{item.contentTitle}}
          </div>
        </div>
      </div>
    </div>
    <div
      style="position: fixed;right: 35px;top: 400px;width: 44px;height: 247px;background-color: #fff;box-shadow: 0px 2px 12px 3px rgba(228,233,233,0.46);border-radius: 22px; writing-mode:lr-tb;text-align: center;padding: 0px 8px;box-sizing: border-box;display: flex;align-items: center;justify-content: center;flex-direction: column;z-index: 999;">
      <div class="kf" style="border-bottom: 1px solid #E7EDF1;padding: 5px 0;position: relative;">
        <img src="../assets/images/kefu@2x.png" style="width: 15px;height: 15px;">
        <div style="font-size: 16px;font-family: PingFangSC-Regular, PingFang SC;color: #36444D;">咨询客服</div>
        <div class="kfQr"
          style="width: 158px;height: 158px;border: 1px solid #00C9AD;position: absolute;left: -190px;top: -35px;padding: 8px 14px;box-sizing: border-box;box-shadow: 0px 2px 12px 3px rgba(228,233,233,0.46);border-radius: 8px;display: none;background: #fff;">
          <div
            style="font-size: 12px;font-family: PingFangSC-Regular, PingFang SC;color: #32454E;line-height: 18px;color: #32454E;">
            添加企业微信<br />为您一对一解答问题
          </div>
          <div>
            <img :src="baseURL + info.kfQrcode" style="width: 99px;height: 99px;">
          </div>
        </div>

      </div>

      <div class="dh" style="padding: 5px 0;position: relative;">
        <div class="redOne"></div>
        <img src="../assets/images/dh@2x.png" style="width: 15px;height: 15px;">
        <div>联系我们</div>
        <div class="phone" style="display: none;">130-4807-9186</div>
        <!-- <el-tooltip class="item" effect="light" content="130-4807-9186" placement="left" popper-class="popperStyle">
          <div style="font-size: 16px;font-family: PingFangSC-Regular, PingFang SC;color: #36444D;">联系我们</div>
        </el-tooltip> -->
      </div>
    </div>
    <div
      style="width: 100%;height: 823px;background: linear-gradient(180deg, #FFFFFF 0%, #F7F9FF 100%);margin: 156px auto 0;box-sizing: border-box;">
      <div
        style="width: 600px;height: 56px;font-size: 40px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #1F2329;line-height: 56px;margin: 0 auto 80px;">
        {{mk2.title}}
      </div>
      <div style="text-align: center;">
        <img :src="baseURL + mk2.fileUrl" alt="" style="width: 999px;height: 609px;">
      </div>

    </div>
    <CodeAdv @fatherMethod="fatherMethod"></CodeAdv>
    <CodeOffic @fatherMethod="fatherMethod"></CodeOffic>
    <CodeBuy @fatherMethod="fatherMethod"></CodeBuy>
    <CodeBusiness></CodeBusiness>
    <CodeCase></CodeCase>
    <div class="bj2">
      <div
        style="width: 240px;height: 56px;font-size: 40px;font-weight: 500;line-height: 56px;margin: 0 auto;color: #1F2329;">
        {{mk8.title}}
      </div>
      <div class="dataGrowth"
        style="display: flex;justify-content: space-between;margin: 150px auto 0;padding: 0 40px;box-sizing: border-box;">
        <div v-for="(item, index) in mk8.moduleChildList" :key="index">
          <div style="display: flex;justify-content: center;align-items: center;position: relative;">
            <div
              style="position: absolute;right: 75px;top: 10px;font-size: 8px;font-family: DINAlternate-Bold, DINAlternate;font-weight: bold;color: #1F2329;line-height: 19px;">
              %</div>
            <div v-if="index == 0" class="num"
              style="font-size: 52px;font-family: DIN-Medium, DIN;font-weight: 500;color: #3C424C;line-height: 63px;">
              {{num1}}
            </div>
            <div v-if="index == 1" class="num"
              style="font-size: 52px;font-family: DIN-Medium, DIN;font-weight: 500;color: #3C424C;line-height: 63px;">
              {{num2}}
            </div>
            <div v-if="index == 2" class="num"
              style="font-size: 52px;font-family: DIN-Medium, DIN;font-weight: 500;color: #3C424C;line-height: 63px;">
              {{num3}}
            </div>
            <div v-if="index == 3" class="num"
              style="font-size: 52px;font-family: DIN-Medium, DIN;font-weight: 500;color: #3C424C;line-height: 63px;">
              {{num4}}
            </div>
            <div v-if="index == 4" class="num"
              style="font-size: 52px;font-family: DIN-Medium, DIN;font-weight: 500;color: #3C424C;line-height: 63px;">
              {{num5}}
            </div>
            <img v-if="index == 4" src="../assets/images/jt_2@2x.png"
              style="width: 28px;height: 29px;margin-left: 10px;">
            <img v-else src="../assets/images/jt_1@2x.png" style="width: 23px;height: 36px;margin-left: 10px;">
          </div>
          <div
            style="font-size: 22px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #3C424C;line-height: 30px;color: #3C424C;margin-top: 23px;">
            {{item.title}}
          </div>
          <div
            style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;line-height: 24px;color: #92A0B4;margin-top: 14px;">
            {{item.content}}
          </div>
        </div>
      </div>
    </div>
    <div class="bj3">
      <div
        style="font-size: 40px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #FFFFFF;line-height: 56px;text-align: center;">
        赋能日化万亿市场</div>
      <div class="marketList">
        <div>
          <img src="../assets/images/01@2x.png" style="width: 46px;height: 45px;margin-bottom: 15px;">
          <div>原料</div>
        </div>
        <div>
          <img src="../assets/images/02@2x.png" style="width: 46px;height: 41px;margin-bottom: 15px;">
          <div>包材</div>
        </div>
        <div>
          <img src="../assets/images/03@2x.png" style="width: 46px;height: 43px;margin-bottom: 15px;">
          <div>物流</div>
        </div>
        <div>
          <img src="../assets/images/04@2x.png" style="width: 40px;height: 48px;margin-bottom: 15px;">
          <div>洗涤剂</div>
        </div>
        <div>
          <img src="../assets/images/05@2x.png" style="width: 36px;height: 51px;margin-bottom: 15px;">
          <div>化妆品</div>
        </div>
        <div>
          <img src="../assets/images/06@2x.png" style="width: 46px;height: 46px;margin-bottom: 15px;">
          <div>更多</div>
        </div>
      </div>
    </div>
    <div style="width: 100%;height: 710px;box-sizing: border-box;padding: 40px 0;">
      <div
        style="font-size: 40px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #1F2329;line-height: 56px;color: #1F2329;text-align: center;">
        新闻资讯</div>
      <div class="xwzx"
        style="margin: 82px auto 0;padding: 0 125px;box-sizing: border-box;display: flex;justify-content: space-between;">
        <img src="../assets/images/infoLeft.png" style="width: 473px;height: 443px;cursor: pointer;" @click="goList">
        <div style="width: 660px;">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="营销干货" name="1"></el-tab-pane>
            <el-tab-pane label="企业动态" name="2"></el-tab-pane>
            <el-tab-pane label="使用指南" name="3"></el-tab-pane>
            <el-tab-pane label="客户案例" name="4"></el-tab-pane>
            <el-tab-pane label="更多文章" name="5"></el-tab-pane>
          </el-tabs>
          <div>
            <div
              style="width: 660px;height: 110px;display: flex;justify-content: flex-start;box-shadow: 0px 2px 10px 0px rgba(220,221,236,0.5);border-radius: 10px;margin-top: 10px;align-items: center;cursor: pointer;"
              v-for="(item, index) in article" :key="index" v-if="index <= 2" @click="toDetails(item.id)">
              <img :src="baseURL + item.image" style="width: 180px;height: 110px;border-radius: 10px;">
              <div style="padding: 0 18px;">
                <div
                  style="font-size: 18px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #1F2329;line-height: 30px;width: 444px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">
                  {{item.title}}
                </div>
                <div
                  style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #6D7C93;line-height: 28px;margin-bottom: 10px;width: 444px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">
                  {{item.contentTitle}}
                </div>
                <div
                  style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #BCC4D2;line-height: 24px;">
                  {{item.publishTime}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bj4">
      <div
        style="width: 160px;height: 50px;border-radius: 38px;border: 1px solid #fff;font-size: 18px;font-size: 18px;
font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #1ED2C7;text-align: center;line-height: 50px;position: absolute;bottom: 46px;cursor: pointer;background: #fff;"
        @click="outerVisible = true">
        立即体验</div>
    </div>
    <div style="width: 100%;height: 240px;">
      <div class="banner2"
        style="height: 240px;margin: 0 auto;display: flex;align-items: center;justify-content: space-between;padding: 0 170px;box-sizing: border-box;">
        <div>
          <img src="../assets/images/rhbsm.png" style="width: 117px;height: 23px;margin-bottom: 23px;">
          <div style="display: flex;justify-content: flex-start;">
            <div style="width: 28px;height: 28px;cursor: pointer;margin-right: 10px;" v-for="(item, index) in media"
              :key="index">

              <div class="weixin" style="display: flex;justify-content: flex-start;position: relative;">
                <img v-if="item.mediaType == 1" src="../assets/images/wx@2x.png"
                  style="width: 28px;height: 28px;cursor: pointer;">
                <img class="erweima" :src="baseURL + item.url"
                  style="width: 100px;height: 100px;position: absolute;top: -105px;left: -35px;">
              </div>
              <div>
                <a v-if="item.mediaType == 2" :href="item.url"><img src="../assets/images/wb@2x.png"
                    style="width: 28px;height: 28px;cursor: pointer;"></a>
              </div>
            </div>
            <!-- <div style="width: 28px;height: 28px;cursor: pointer;margin-right: 10px;">
              <img src="../assets/images/wx@2x.png" style="width: 28px;height: 28px;cursor: pointer;">
            </div>

            <img src="../assets/images/wb@2x.png" style="width: 28px;height: 28px;cursor: pointer;"> -->
          </div>
        </div>
        <div>
          <div
            style="font-size: 16px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #1F2329;line-height: 64px;">
            友情链接</div>
          <div>
            <span
              style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;color: #6C7480;line-height: 32px;margin-right: 40px;cursor: pointer;"
              v-if="linkList[0]"><a :href="linkList[0].linkUrl">{{linkList[0].linkName}}</a></span>
            <span
              style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;color: #6C7480;line-height: 32px;cursor: pointer;"
              v-if="linkList[1]"><a :href="linkList[1].linkUrl">{{linkList[1].linkName}}</a></span>
          </div>
          <div
            style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;color: #6C7480;line-height: 32px;cursor: pointer;"
            v-if="linkList[2]"><a :href="linkList[2].linkUrl">{{linkList[2].linkName}}</a></div>
        </div>
        <div>
          <div style="font-size: 16px;font-family: PingFang-SC-Medium, PingFang-SC;color: #1F2329;line-height: 64px;">
            联系我们</div>
          <div
            style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;line-height: 32px;color: #6C7480;">
            Tel：{{info.tel}}</div>
          <!-- <div
            style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;line-height: 32px;color: #6C7480;">
            公司地址：{{info.address}}</div> -->
        </div>
      </div>

    </div>
    <!-- <div
      style="width: 100%;height: 50px;background-color: #F2F4F6;text-align: center;font-size: 12px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #6C7480;line-height: 25px;padding: 10px 0;">
      {{info.copyright}} <br /> {{info.websiteBa}}
    </div> -->
<div
      style="width: 100%;height: 50px;background-color: #F2F4F6;text-align: center;font-size: 12px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #6C7480;line-height: 25px;padding: 10px 0;display: flex;align-items: center;justify-content: center;">
      <a href="https://beian.miit.gov.cn" style="color: #2b90fc;">备案号：{{info.websiteBa}}</a>
    </div>
    <el-dialog :visible.sync="outerVisible" :show-close="false">
      <div style="width: 643px;height: 690px;position: relative;">
        <div class="dialogImg">
          <div>
            <div
              style="font-size: 26px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #0A0909;line-height: 37px;">
              日化标识码申请体验预约</div>
            <div
              style="font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;line-height: 20px;letter-spacing: 3px;margin-top: 14px;">
              让营销更简单，让增长更顺畅，让品质更可靠</div>
          </div>
          <div>
            <img src="../assets/images/sc_yy@2x.png" style="width: 178px;height: 117px;">
          </div>
        </div>
        <div style="width: 530px;margin-left: 66px;">
          <el-form :model="dynamicValidateForm" ref="dynamicValidateForm">
            <div>
              <div style="padding: 15px 0;"><span style="color: #CA2325">*</span> <span
                  style="color: #0A0909;font-size: 14px;">您的名字</span></div>
              <el-form-item prop="name" :rules="[{ required: true, message: '姓名不能为空'}]">
                <el-input style="width: 476px;height: 45px;" v-model="dynamicValidateForm.name" placeholder="希望我们如何称呼您">
                </el-input>
              </el-form-item>

            </div>
            <div>
              <div style="padding-bottom: 15px;"><span style="color: #CA2325">*</span> <span
                  style="color: #0A0909;font-size: 14px;">手机/电话</span></div>
              <el-form-item prop="tel" :rules="[{ required: true, message: '电话不能为空'}]">
                <el-input style="width: 476px;height: 45px;" v-model="dynamicValidateForm.tel"
                  placeholder="顾问将于1-2个工作日内给您致电"></el-input>
              </el-form-item>

            </div>
            <div>
              <div style="padding-bottom: 15px;"><span style="color: #CA2325">*</span> <span
                  style="color: #0A0909;font-size: 14px;">企业名称</span></div>
              <el-form-item prop="enterpriseName" :rules="[{ required: true, message: '名称不能为空'}]">
                <el-input style="width: 476px;height: 45px;" v-model="dynamicValidateForm.enterpriseName"
                  placeholder="请提供完整的工商注册名称，否则可能导致申请失败"></el-input>
              </el-form-item>

            </div>
          </el-form>
          <div
            style="font-size: 12px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #A1AAB9;line-height: 22px;">
            温馨提示：体验申请通过后您将获得 <br />1、您的企业可免费享受一次价值1000元的【产品顾问一对一讲解】服务 <br />
            2、服务由日化标识码客户服务中心提供，时长约30分钟，包含产品的功能讲解行业优秀案列分享。<br /> 3、产品可免费体验15天。
          </div>
          <div
            style="font-size: 16px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #FFFFFF;line-height: 22px;background: linear-gradient(270deg, #14E1A0 0%, #02B4E0 100%);border-radius: 23px;width: 302px;height: 45px;text-align: center;line-height: 45px;margin: 0 auto;margin-top: 28px;cursor: pointer;"
            @click="setSubmit('dynamicValidateForm')">
            立即体验</div>

        </div>
        <img src="../assets/images/dialogLeft.png"
          style="width: 100px;height: 48px;position: absolute;bottom: 80px;left: 30px;">
        <img src="../assets/images/dialogBottom.png"
          style="width: 322px;height: 58px;position: absolute;bottom: 0px;right: 0px;">
        <div style="position: absolute;bottom: -70px;margin: 0 auto;width: 100%;text-align: center;">
          <img src="../assets/images/gb@2x.png" style="width: 30px;height: 30px;" @click="outerVisible = false">
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import {
    setHotArticles,
    getIndex,
    getArticle,
    getLinks,
    getInfo,
    getMedia,
    submit
  } from '@/api/api'
  import {
    serverUrl
  } from '@/utils/server'
  import CodeAdv from './components/CodeAdv'
  import CodeOffic from './components/CodeOffic'
  import CodeBuy from './components/CodeBuy'
  import CodeBusiness from './components/CodeBusiness'
  import CodeCase from './components/CodeCase'
  import Head from './components/Head'
  export default {
    name: 'home',
    components: {
      CodeAdv,
      CodeOffic,
      CodeBuy,
      CodeBusiness,
      CodeCase,
      Head
    },
    data() {
      return {
        dynamicValidateForm: {
          name: '',
          tel: '',
          enterpriseName: ''
        },
        flag: false,
        num1: 0,
        num2: 0,
        num3: 0,
        num4: 0,
        num5: 0,
        hotArticlesList: [],
        mk1: {},
        mk2: {},
        mk8: {
          moduleChildList: {}
        },
        activeName: '1',
        baseURL: '',
        article: [],
        linkList: [],
        info: {},
        media: [],
        yuanshu: 0,
        outerVisible: false,
        flag: false
      }
    },
    methods: {
      fatherMethod() {
        this.outerVisible = true
      },
      setSubmit(formName) {
        console.log('===')
        this.$refs[formName].validate((valid) => {
          if (valid) {
            submit(this.dynamicValidateForm).then(res=> {
              this.outerVisible = false
              this.$message({
                message: '申请成功！',
                type: 'success'
              });
            })

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      toDetails(id) {
        this.$router.push({
          path: '/newsDetails',
          query: {
            id
          }
        })
      },
      getHotArticles() {
        setHotArticles().then(res => {
          this.hotArticlesList = res
        })
      },
      setIndex1() {
        if (!this.flag) {
          return;
        }
        getIndex().then(res => {
          console.log('==============')
          this.mk8 = res.mk8
          var that = this
          var test1 = setInterval(function() {
            that.num1 = that.num1 + 1
            if (that.mk8.moduleChildList[0].subtitle == that.num1) {
              clearInterval(test1);
            }
            console.log('执行定时器')
          }, 100)

          var test2 = setInterval(function() {
            that.num2 = that.num2 + 1
            if (that.mk8.moduleChildList[1].subtitle == that.num2) {
              clearTimeout(test2);
            }
          }, 100)
          var test3 = setInterval(function() {
            that.num3 = that.num3 + 1
            if (that.mk8.moduleChildList[2].subtitle == that.num3) {
              clearTimeout(test3);
            }
          }, 100)
          var test4 = setInterval(function() {
            that.num4 = that.num4 + 1
            if (that.mk8.moduleChildList[3].subtitle == that.num4) {
              clearTimeout(test4);
            }
          }, 100)
          var test5 = setInterval(function() {
            that.num5 = that.num5 + 1
            if (that.mk8.moduleChildList[4].subtitle == that.num5) {
              clearTimeout(test5);
            }
          }, 100)

        })
      },
      setIndex() {
        getIndex().then(res => {
          this.mk1 = res.mk1
          this.mk2 = res.mk2
        })
      },
      setArticle() {
        getArticle({
          type: this.activeName
        }).then(res => {
          this.article = res.content
        })
      },
      setLinks() {
        getLinks().then(res => {
          this.linkList = res
        })
      },
      setInfo() {
        getInfo().then(res => {
          this.info = res
        })
      },
      setMedia() {
        getMedia().then(res => {
          this.media = res
        })
      },
      goList() {
        this.$router.push({
          path: '/newsList',
        })
      },
      handleClick(tab, event) {
        console.log(this.activeName)
        if (this.activeName == 5) {
          this.$router.push({
            path: '/newsList',
          })
          return;
        }

        this.setArticle()
      },
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 4000) {
          if (this.flag) {
            return
          } else {
            this.flag = true
            this.setIndex1()
          }

        }
      },
    },
    mounted() {

      window.addEventListener('scroll', this.handleScroll)
      this.baseURL = serverUrl.baseURL
      this.getHotArticles()
      this.setIndex()
      this.setArticle()
      this.setLinks()
      this.setInfo()
      this.setMedia()
      // this.init()
    },
    created() {
      // this.indexList()
      if (screen.width < 768) {
        this.$router.push({
          path: "/mobile"
        })
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @media (max-width: 1500px) {

    .logo,
    .banner1,
    .xwzx,
    .banner2,
    .dataGrowth {
      width: 1440px;
    }

    .bj1 {
      box-sizing: border-box;
      width: 1274px;
      height: 184px;
      margin: 0 auto;
      position: absolute;
      bottom: -92px;
      background: url(../assets/images/bj_1.png) top center no-repeat;
      background-size: cover;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .hotArticlesTitle {
      width: 334px;
    }

    .hotArticlesContent {
      width: 334px;
    }


  }

  @media (min-width: 1500px) {

    .logo,
    .banner1,
    .xwzx,
    .banner2,
    .dataGrowth {
      width: 1640px;
    }

    .bj1 {
      box-sizing: border-box;
      width: 1434px;
      height: 184px;
      margin: 0 auto;
      position: absolute;
      bottom: -92px;
      background: url(../assets/images/bj_1@2x.png) top center no-repeat;
      background-size: cover;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .hotArticlesTitle {
      width: 388px;
    }

    .hotArticlesContent {
      width: 388px;
    }
  }

  .bj1>div {
    width: 33%;
    margin: 0 45px;
    position: relative;
  }

  .bj1>div:not(:last-child)::before {
    content: "";
    position: absolute;
    right: -40px;
    top: 25px;
    display: block;
    height: 46px;
    background: #e9e9ef;
    border: 1px solid #E9E9EF;
  }

  .banner {
    width: 100%;
    height: 620px;
    background: url(../assets/images/banner.png) top center no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    justify-content: center;
  }



  .bj2 {
    width: 100%;
    height: 560px;
    margin: 0 auto;
    background: url(../assets/images/bj_2.png) top center no-repeat;
    background-size: cover;
    padding: 62px 0;
    box-sizing: border-box;
  }

  .bj3 {
    width: 100%;
    height: 560px;
    margin: 0 auto;
    background: url(../assets/images/bj_3.png) top center no-repeat;
    background-size: cover;
    padding: 82px 0;
    box-sizing: border-box;
  }

  .bj4 {
    width: 100%;
    height: 258px;
    margin: 0 auto;
    background: url(../assets/images/bj_4.png) top center no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    justify-content: center;
  }

  ::-webkit-scrollbar {
    display: none !important;
    /* Chrome */
  }

  .contain {
    overflow-x: hidden;
    min-height: 100vh;
    position: relative;
  }

  .dataGrowth>div {
    width: 260px;
    text-align: center;
    padding: 0 30px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .marketList {
    display: flex;
    justify-content: space-between;
    width: 1236px;
    margin: 82px auto 0;
  }

  .marketList>div {
    width: 206px;
    height: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer;
  }

  .marketList>div:nth-child(1) {
    background: url(../assets/images/1@2x.png) top center no-repeat;
    background-size: cover;
  }

  .marketList>div:nth-child(2) {
    background: url(../assets/images/2@2x.png) top center no-repeat;
    background-size: cover;
  }

  .marketList>div:nth-child(3) {
    background: url(../assets/images/3@2x.png) top center no-repeat;
    background-size: cover;
  }

  .marketList>div:nth-child(4) {
    background: url(../assets/images/4@2x.png) top center no-repeat;
    background-size: cover;
  }

  .marketList>div:nth-child(5) {
    background: url(../assets/images/5@2x.png) top center no-repeat;
    background-size: cover;
  }

  .marketList>div:nth-child(6) {
    background: #3D446A;
  }

  /deep/ .el-tabs__nav-wrap::after {
    background-color: #fff
  }

  /deep/ .el-tabs__item {
    width: 132px;
    color: #1F2329;
    font-size: 20px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    height: 50px;
  }

  /deep/ .el-tabs__active-bar {
    left: 20px;
    width: 40px !important;
    height: 4px;
    background: #1ED2C7;
    border-radius: 4px;
  }

  a {
    color: #6C7480;
  }

  .erweima {
    display: none;
  }

  .weixin:hover .erweima {
    display: block !important;
  }

  .kf:hover {
    background: #F8FFFF;
    border-radius: 100px 100px 0px 0px;
  }

  .kf:hover .kfQr {
    display: block !important;
  }

  .dh:hover {
    background: #F8FFFF;
    border-radius: 0px 0px 100px 100px;
  }

  .redOne {
    display: none;
    width: 0;
    height: 0;
    border-top: 9px solid transparent;
    border-left: 9px solid #fff;
    border-bottom: 9px solid transparent;
    position: absolute;
    left: -26px;
    top: 40px;
    box-shadow: rgba(228, 233, 233, 0.46);
    filter: drop-shadow(5px 5px 10px #e9e9e9)
  }

  .dh:hover .redOne {
    display: block !important;

  }

  .phone {
    font-size: 16px;
    font-family: DINMittelschriftStd;
    color: #69757D;
    line-height: 20px;
    border-radius: 6px;
    box-shadow: 0px 2px 12px 3px rgba(228, 233, 233, 0.46);
  }

  .dh:hover .phone {
    position: absolute;
    left: -190px;
    top: 30px;
    display: block !important;
    background: #FFFFFF;
    padding: 5px 10px;
    width: 144px;
    height: 30px;
    text-align: center;
    line-height: 30px;
  }

  /deep/ .el-dialog {
    width: 643px;
    border-radius: 18px;
  }

  /deep/ .el-dialog__body {
    padding: 0;
  }

  /deep/ .el-dialog__header {
    padding: 0 !important;
    display: none !important;
  }

  .dialogImg {
    width: 643px;
    height: 169px;
    background: url(../assets/images/dialogBanner.png) top center no-repeat;
    background-size: cover;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 35px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue